<template>
  <div class="meetingReservation_week">
    <!-- 会议室预定 周 -->
    <el-form ref="meetingWeek" v-loading="loading" :model="{}">
        <div class="el-table el-table--fit el-table--border">
          <div class="el-table__body-wrapper">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
              <tbody>
                <tr>
                    <td class="el-table__cell tdcont tdw17" colspan="1"> <div class="header"> 会议室</div></td>
                    <td v-for="(week,index) in meetingWeek" :key="index" class="el-table__cell tdcont tdw17" :class="week.isToday?'today_header':''" colspan="1">
                        <div class="header">{{ week.date }} {{ week.week }}</div>
                    </td>
                </tr>
                <tr v-for="(room,index) in meetPlace" :key="index">
                    <td class="el-table__cell tdcont tdw17" colspan="1"> <div class="header"> {{ room.name }}</div></td>
                    <td v-for="(weekday,idx) in room.weekdays" :key="index+'_'+idx" class="el-table__cell tdcont tdw17" colspan="1">
                        <div v-if="weekday.meetingList.length" class="meeting_items">
                            <span v-for="(item, idxm) in weekday.meetingList" :key="index+'_'+idx+'_'+idxm" :class="new Date(item.endTime).getTime() > new Date().getTime()?'meeting_item_past':'meeting_item'" @click="toApplyClick(room, weekday.weekday)">
                                <el-popover placement="right" width="300" trigger="hover">
                                    <div class="meet_item_detail">
                                        <div style="margin-bottom:8px;line-height: 18px;">{{ item.meetSubjedt }}</div>
                                        <div style="line-height: 20px;">预约人：{{ item.applayName }}</div>
                                        <div style="line-height: 20px;">联系方式：{{ item.phone }}</div>
                                        <div style="line-height: 20px;">时间：{{ $moment(new Date(item.beginTime)).format('YYYY-MM-DD HH:mm') }}-{{ $moment(new Date(item.endTime)).format('HH:mm') }}</div>
                                        <div v-if="(item.applayName==loginUser.personName||isAdmin)&& !$moment(item.beginTime).isBefore($moment())" class="bnt_cancel" @click.stop="cancelMeeting(item)">取消预约</div>
                                    </div>
                                   <div slot="reference" @click.stop="rowClick(item,room)">{{ item.meetSubjedt }}</div>
                                </el-popover>
                            </span>
                        </div>
                        <div v-else class="meeting_items">
                            <template v-if="new Date(weekday.weekdayTime) >= new Date()">
                                <div class="to_apply" @click="toApplyClick(room, weekday.weekday)">
                                    <span>预定</span>
                                </div>
                            </template>
                        </div>
                    </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-form>
  </div>
</template>

<script>
const moment = require('moment')
export default {
    props: {

    },
    data() {
        return {
            loading: false,
            loginUser: this.$store.getters.loginUser,
            meetingWeek: [], // 记录一周的时间
            meetPlace: [], // 会议室地点
            weekArr: [], //
            isAdmin: false // 是否是管理员
        }
    },
    created() {
        this.isAdmin = this.$store.state.user.roles.includes('hygl')
        this.$bus.on('weekTimeChanged', this.weekTimeChanged)
    },
    mounted() {
    },
    beforeDestroy() {
        this.$bus.off('weekTimeChanged', this.weekTimeChanged)
    },
    methods: {
        weekTimeChanged(week, weekArr) {
            this.meetingWeek = week
            this.weekArr = week
            this.getMeetingRoomData(weekArr[0], weekArr[1])
            // this.queryDataHy(weekArr).then((result) => {
            //     if (result.code === 'success') {
            //         console.log('result', result)
            //     } else {
            //         this.$message.error(result.message)
            //     }
            // })
        },
        queryDataHy(arr) {
            // 查询个人某段范围内的日程
            return new Promise((resolve, reject) => {
                this.$http({
                    method: 'POST',
                    contentType: 'application/x-www-form-urlencoded',
                    data: [
                        { compare: '<=', field: 'startTime', merge: false, value: moment(arr[1]).format('YYYY-MM-DD HH:mm:ss')},
                        { compare: '>=', field: 'endTime', merge: false, value: moment(arr[0]).format('YYYY-MM-DD HH:mm:ss')},
                        { compare: 'in', field: 'status', merge: false, value: '1,2'},
                        { compare: '=', field: 'personId', merge: false, value: this.loginUser.personId},
                        { compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode},
                        { compare: '!=', field: 'meetPersonType', merge: true, value: 4}
                    ],
                    url: '/hygl/vwMyMeeting/querydata'
                }).then((response) => {
                    resolve(response)
                })
            })
        },
        /**
         * 该场地下的会议室信息
         */
        getMeetingRoomData(startDate, endDate, cbFunc = null) {
            var temp = {
                'body': {
                    'listdata': [
                        {
                            'approve': 1,
                            'deviceProperties': '投影仪,大屏幕,话筒',
                            'id': 'f9b06f962ede4255b08d54e4c804fdbd',
                            'layoutName': 'U型桌-长边共10人，短边共1人',
                            'meetImgname': null,
                            'meetImgurl': null,
                            'name': '12楼会议室',
                            'numPeople': 100,
                            'openday': '周一,周二,周三,周四,周五',
                            'rbegintime': '08:00',
                            'rendtime': '20:00',
                            'serviceProperties': '矿泉水,下午茶,水果',
                            'weekdays': [
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-03'
                                },
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-04'
                                },
                                {
                                    'meetingList': [
                                        {
                                            'agentId': null,
                                            'agentPhone': null,
                                            'agentUser': null,
                                            'applayName': '黄多',
                                            'applyUserid': 'bf7c7d7ec270483886e86edbba5b30f2',
                                            'attendDept': null,
                                            'attendLeader': null,
                                            'attendUserId': null,
                                            'attendUserName': null,
                                            'beginTime': '2025-02-05 18:10:00',
                                            'createTime': '2025-02-05 18:10:57',
                                            'departmentUser': '综合部',
                                            'deviceProperties': null,
                                            'endTime': '2025-02-05 18:50:00',
                                            'groupId': null,
                                            'id': 'c2cd21076b214967a8c150eaea9daa3a',
                                            'isParent': null,
                                            'meetDetails': '会议内容会议内容会议内容',
                                            'meetName': '12楼会议室',
                                            'meetRoomId': 'f9b06f962ede4255b08d54e4c804fdbd',
                                            'meetSubjedt': '会议主题会议主题',
                                            'numPeople': 100,
                                            'orgCode': 'tsys',
                                            'orgName': '广东易臣信息技术有限公司',
                                            'passenger': {
                                                'busiDataId': '',
                                                'status': null
                                            },
                                            'phone': '13700000009',
                                            'preordainType': '0',
                                            'remark': null,
                                            'remindType': null,
                                            'serviceProperties': null,
                                            'site': null,
                                            'status': 1,
                                            'userName': null,
                                            'week': null,
                                            'weekProperties': '周一,周二,周三,周四,周五'
                                        },
                                        {
                                            'agentId': null,
                                            'agentPhone': null,
                                            'agentUser': null,
                                            'applayName': '黄多',
                                            'applyUserid': 'bf7c7d7ec270483886e86edbba5b30f2',
                                            'attendDept': null,
                                            'attendLeader': null,
                                            'attendUserId': null,
                                            'attendUserName': null,
                                            'beginTime': '2025-02-05 19:00:00',
                                            'createTime': '2025-02-05 15:52:01',
                                            'departmentUser': '工程部',
                                            'deviceProperties': '投影仪,大屏幕,话筒',
                                            'endTime': '2025-02-05 20:00:00',
                                            'groupId': null,
                                            'id': '0d53dc9a80f04fbeb74ca5bc54d3f3bd',
                                            'isParent': null,
                                            'meetDetails': '会议内容会议内容会议内容会议内容',
                                            'meetName': '12楼会议室',
                                            'meetRoomId': 'f9b06f962ede4255b08d54e4c804fdbd',
                                            'meetSubjedt': '会议室申请20250205UPRN',
                                            'numPeople': 100,
                                            'orgCode': 'tsys',
                                            'orgName': '广东易臣信息技术有限公司',
                                            'passenger': {
                                                'busiDataId': '0d53dc9a80f04fbeb74ca5bc54d3f3bd',
                                                'status': 1
                                            },
                                            'phone': '13700000009',
                                            'preordainType': '0',
                                            'remark': '提前5分钟入场',
                                            'remindType': 0,
                                            'serviceProperties': '矿泉水,下午茶,水果',
                                            'site': '中公教育大厦',
                                            'status': 2,
                                            'userName': null,
                                            'week': '周一,周二,周三,周四,周五',
                                            'weekProperties': '周一,周二,周三,周四,周五'
                                        }
                                    ],
                                    'weekday': '2025-02-05'
                                },
                                {
                                    'meetingList': [
                                        {
                                            'agentId': null,
                                            'agentPhone': null,
                                            'agentUser': null,
                                            'applayName': '黄多',
                                            'applyUserid': 'bf7c7d7ec270483886e86edbba5b30f2',
                                            'attendDept': null,
                                            'attendLeader': null,
                                            'attendUserId': null,
                                            'attendUserName': null,
                                            'beginTime': '2025-02-06 18:10:00',
                                            'createTime': '2025-02-06 18:10:57',
                                            'departmentUser': '综合部',
                                            'deviceProperties': null,
                                            'endTime': '2025-02-06 18:50:00',
                                            'groupId': null,
                                            'id': 'c2cd21076b214967a8c150eaea9daa3a',
                                            'isParent': null,
                                            'meetDetails': '会议内容会议内容会议内容',
                                            'meetName': '12楼会议室',
                                            'meetRoomId': 'f9b06f962ede4255b08d54e4c804fdbd',
                                            'meetSubjedt': '会议主题会议主题',
                                            'numPeople': 100,
                                            'orgCode': 'tsys',
                                            'orgName': '广东易臣信息技术有限公司',
                                            'passenger': {
                                                'busiDataId': '',
                                                'status': null
                                            },
                                            'phone': '13700000009',
                                            'preordainType': '0',
                                            'remark': null,
                                            'remindType': null,
                                            'serviceProperties': null,
                                            'site': null,
                                            'status': 1,
                                            'userName': null,
                                            'week': null,
                                            'weekProperties': '周一,周二,周三,周四,周五'
                                        },
                                        {
                                            'agentId': null,
                                            'agentPhone': null,
                                            'agentUser': null,
                                            'applayName': '黄多',
                                            'applyUserid': 'bf7c7d7ec270483886e86edbba5b30f2',
                                            'attendDept': null,
                                            'attendLeader': null,
                                            'attendUserId': null,
                                            'attendUserName': null,
                                            'beginTime': '2025-02-06 19:00:00',
                                            'createTime': '2025-02-06 15:52:01',
                                            'departmentUser': '工程部',
                                            'deviceProperties': '投影仪,大屏幕,话筒',
                                            'endTime': '2025-02-06 20:00:00',
                                            'groupId': null,
                                            'id': '0d53dc9a80f04fbeb74ca5bc54d3f3bd',
                                            'isParent': null,
                                            'meetDetails': '会议内容会议内容会议内容会议内容',
                                            'meetName': '12楼会议室',
                                            'meetRoomId': 'f9b06f962ede4255b08d54e4c804fdbd',
                                            'meetSubjedt': '会议室申请20250205UPRN',
                                            'numPeople': 100,
                                            'orgCode': 'tsys',
                                            'orgName': '广东易臣信息技术有限公司',
                                            'passenger': {
                                                'busiDataId': '0d53dc9a80f04fbeb74ca5bc54d3f3bd',
                                                'status': 1
                                            },
                                            'phone': '13700000009',
                                            'preordainType': '0',
                                            'remark': '提前5分钟入场',
                                            'remindType': 0,
                                            'serviceProperties': '矿泉水,下午茶,水果',
                                            'site': '中公教育大厦',
                                            'status': 2,
                                            'userName': null,
                                            'week': '周一,周二,周三,周四,周五',
                                            'weekProperties': '周一,周二,周三,周四,周五'
                                        }
                                    ],
                                    'weekday': '2025-02-06'
                                },
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-07'
                                },
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-08'
                                },
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-09'
                                }
                            ]
                        },
                        {
                            'approve': 0,
                            'deviceProperties': '投影仪,话筒',
                            'id': '04c5b93850c84f5cb9a8895ab3716948',
                            'layoutName': '圆型桌-8人',
                            'meetImgname': null,
                            'meetImgurl': null,
                            'name': '小会议室',
                            'numPeople': 20,
                            'openday': '周二,周三,周六,周日',
                            'rbegintime': '09:00',
                            'rendtime': '18:00',
                            'serviceProperties': '矿泉水',
                            'weekdays': [
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-03'
                                },
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-04'
                                },
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-05'
                                },
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-06'
                                },
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-07'
                                },
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-08'
                                },
                                {
                                    'meetingList': [

                                    ],
                                    'weekday': '2025-02-09'
                                }
                            ]
                        }
                    ]
                },
                'code': 'success',
                'message': '处理成功！'
            }
            this.loading = true
            this.$http({
                method: 'GET',
                url: 'hygl/meeting/queryMeetingRoomReserveInfo',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    siteId: this.$vnode.context.searchFilter.siteId
                }
            }).then((res) => {
                if (res.code === 'success') {
                    // var list = temp.body.listdata
                    var list = res.body.listdata
                    list = list.map((item) => {
                        if (item.weekdays && item.weekdays.length) {
                            item.weekdays = item.weekdays.map((meet) => {
                                meet.weekdayTime = meet.weekday + ' 23:59:59'
                                return meet
                            })
                        }
                        return item
                    })
                    console.log('list', list)

                    this.meetPlace = list
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.loading = false
            })
        },
        rowClick(row, room) {
            // approve：1 直接预定  0 申请
            console.log(row)
            const _this = this
            if (room.approve === 1) {
                const moduleInfo = {'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/hygl/meeting/form.html', 'winWidth': 1000, 'delUrl': 'hygl/meeting/delete', 'addNewUrl': 'hygl/meeting/addNew', 'insertUrl': 'hygl/meeting/insert', 'moduleCode': 'meeting', 'listAdvSearchExpandPanel': 0, 'winHeight': 600, 'updateUrl': 'hygl/meeting/update', 'listDataUrl': 'hygl/meeting/listdata', 'getByIdUrl': 'hygl/meeting/getById', 'listAdvSearchAllFields': 0, 'openViewType': '0'}
                moduleInfo.room = row
                const openPage = window.open('#/mr?voId=' + row.id + '&moduleInfo=' + encodeURIComponent(JSON.stringify(moduleInfo)) + '&title=' + encodeURIComponent('会议通知') + '&moduleTitle=' + encodeURIComponent('会议管理') + '&busiInfo=' + encodeURIComponent('会议通知') + '&formUrl=hygl.meeting.form_newForm&innerUrl=&noEdit=false&canEdit=1')
                const loop = setInterval(() => {
                    if (openPage && openPage.closed) {
                        _this.$vnode.context.getSiteData()
                        clearInterval(loop)
                    }
                }, 1500)
            } else if (room.approve === 0) {
                window.open(`#/wflow?wfEngineUrl=hygl/roomApply&busiDataId=${row.id}`)
            }
        },
        // 预定
        toApplyClick(room, day) {
            window.open(`#/wflow?wfEngineUrl=hygl/roomApply&busiCode=roomApply&wfName=会议室申请&startNodeName=&names=新增&name=${room.name}&site=${this.$vnode.context.selectedSite}&weekday=${day}&siteId=${this.$vnode.context.searchFilter.siteId}&id=${room.id}`)
        },
        // 取消预约
        cancelMeeting(meet) {
            this.$confirm('是否确认取消预订?', '操作提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: `/hygl/meeting/cancelMeeting`,
                    method: 'PUT',
                    data: meet
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success('处理成功。')
                        this.weekTimeChanged(this.meetingWeek, this.weekArr)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        }
    }
}
</script>

<style scoped lang="scss">
.meetingReservation_week {
  width: 100%;
  .el-table .el-table__cell {
    // text-align: center;
  }
  .header {
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .el-form .el-table__body td.tdw17 {
    padding: 0;
  }

}
.today_header {
    background-color: #409eff;
    color: #fff;
}
.meeting_items {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 120px;
    .meeting_item {
        position: relative;
        width: 100%;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        background-color: #1ad9a5;
        color: #fff;
        line-height: 30px;
        margin-bottom: 1px;
        padding: 0 0px 0 15px;
        &:last-child {
            margin-bottom: 0;
        }
        &::before {
            content: '';
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 5px;
            transform: translateY(-50%);
            width:5px;
            height: 5px;
            border-radius: 50%;
            background-color: #fff;
        }
    }
    .meeting_item_past {
        position: relative;
        width: 100%;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        background-color: #f5f5f5;
        color: #666;
        line-height: 30px;
        margin-bottom: 1px;
        padding: 0 0px 0 15px;
        &:last-child {
            margin-bottom: 0;
        }
        &::before {
            content: '';
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 5px;
            transform: translateY(-50%);
            width:5px;
            height: 5px;
            border-radius: 50%;
            background-color: #1ad9a5;
        }
    }

    .to_apply {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        min-height: 120px;
        color:#999;
        span {
            display: none;
        }
        &:hover span{
            display: block;

        }
    }

}
.bnt_cancel {
    display: inline-block;
    border: 1px solid #409eff;
    color: #409eff;
    padding: 4px 8px;
    margin-top: 5px;
    cursor: pointer;
}
</style>
